import * as React from 'react';
import { IconPhone16 } from '@cian/ui-kit/icons';
import { UIHeading5 } from '@cian/ui-kit';

import { Button } from '../../components/Button';
import { CallbackPopup } from '../CallbackPopup';
import { trackCallbackPopupOpen } from '../../services/callback';
import { ECallbackPlace } from '../../types/callback';

interface ICallbackProps {
  place: ECallbackPlace;
}

export function Callback({ place }: ICallbackProps) {
  const [showPopup, setShowPopup] = React.useState(false);

  const handlePopupOpen = React.useCallback(() => {
    setShowPopup(prevState => !prevState);
    trackCallbackPopupOpen(place);
  }, [place]);

  const handlePopupClose = React.useCallback(() => setShowPopup(false), []);

  return (
    <>
      <Button
        size="small"
        icon={<IconPhone16 color="white_100" />}
        onClick={handlePopupOpen}
        testId="CallbackFormButton"
      >
        <UIHeading5 color="white_100">Обратный звонок</UIHeading5>
      </Button>

      <CallbackPopup open={showPopup} onClose={handlePopupClose} place={place} />
    </>
  );
}
